export const VERIFICATION_RESULTS_LETTERS_GET_COUNTS =
  'VERIFICATION_RESULTS_LETTERS_GET_COUNTS';
export const VERIFICATION_RESULTS_LETTERS_UPDATE_HISTORY =
  'VERIFICATION_RESULTS_LETTERS_UPDATE_HISTORY';
export const VERIFICATION_RESULTS_LETTERS_GET_REPORT =
  'VERIFICATION_RESULTS_LETTERS_GET_REPORT';
export const VERIFICATION_RESULTS_LETTERS_ERROR =
  'VERIFICATION_RESULTS_LETTERS_ERROR';
export const VERIFICATION_RESULTS_LETTERS_LOADING =
  'VERIFICATION_RESULTS_LETTERS_LOADING';
export const VERIFICATION_RESULTS_LETTERS_CLEAR_REPORT =
  'VERIFICATION_RESULTS_LETTERS_CLEAR_REPORT';
export const VERIFICATION_RESULTS_LETTERS_UPDATE_SELECTED =
  'VERIFICATION_RESULTS_LETTERS_UPDATE_SELECTED';



// WEBPACK FOOTER //
// ./src/pages/resultsletters/state/report/types.js